import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab, Typography } from '@mui/material';
import { Title } from 'react-admin';
import { TemplateList } from '../components/Templates/TemplateList';
import { TemplateEditor } from '../components/Templates/TemplateEditor';
import { TemplateAssignments } from '../components/Templates/TemplateAssignments';
import { DocumentTemplate } from '../components/Templates/types';

export const TemplatesPage: React.FC = () => {
    const [selectedTemplate, setSelectedTemplate] = useState<DocumentTemplate | null>(null);
    const [activeTab, setActiveTab] = useState(0);

    const handleEditTemplate = (template: DocumentTemplate) => {
        setSelectedTemplate(template);
    };

    const handleBack = () => {
        setSelectedTemplate(null);
    };

    const handleSave = (updatedTemplate: DocumentTemplate) => {
        setSelectedTemplate(updatedTemplate);
    };

    if (selectedTemplate) {
        return (
            <TemplateEditor
                template={selectedTemplate}
                onBack={handleBack}
                onSave={handleSave}
            />
        );
    }

    return (
        <Box sx={{ p: 2 }}>
            <Title title="Dokumentenvorlagen" />

            <Paper sx={{ p: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={(_, newValue) => setActiveTab(newValue)}
                    sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
                >
                    <Tab label="Vorlagen" />
                    <Tab label="Zuweisungen" />
                </Tabs>

                {activeTab === 0 && (
                    <>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Erstellen und bearbeiten Sie Vorlagen für Rechnungen, E-Mails, Zertifikate und Erinnerungen.
                            Verwenden Sie Platzhalter wie {'{{kundenname}}'} um dynamische Inhalte einzufügen.
                        </Typography>
                        <TemplateList onEditTemplate={handleEditTemplate} />
                    </>
                )}

                {activeTab === 1 && (
                    <>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Legen Sie fest, welche Vorlage für welchen Zweck verwendet wird.
                            Jeder Zweck kann genau eine aktive Vorlage haben.
                        </Typography>
                        <TemplateAssignments onEditTemplate={handleEditTemplate} />
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default TemplatesPage;
